import CustomerList from './CustomerList'
import Feedback from './Feedback'
import Customer from './Customer'
import Loyalty from './Loyalty'
export default Customer

export {
  CustomerList,
  Feedback,
  Loyalty
}



// WEBPACK FOOTER //
// ./app/pages/Customers/index.js